import request from '@/utils/request';
//登录
export function login(parm) {
  return request({
    url: '/user/userinfo/login',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}

//验证后登录
export function verifylogin(parm) {
  return request({
    url: '/user/userinfo/verifylogin',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: parm,
  });
}

//登录后获取验证码,登录验证也使用这个接口
export function sendmodifycode(parm) {
  return request({
    url: '/user/userinfo/sendmodifycode',
    method: 'post',
    data: parm,
  });
}
//登录前获取验证码
export function sendvalidcode(parm) {
  return request({
    url: '/user/userinfo/sendvalidcode',
    method: 'post',
    data: parm,
  });
}
// 获取用户详细信息
export function getInfo(parm) {
  return request({
    url: '/user/userinfo/info',
    method: 'post',
    data: parm,
  });
}

// 退出方法
export function logout() {
  return request({
    url: '/user/userinfo/logout',
    method: 'post',
  });
}
// 刷新方法
export function refreshToken() {
  return request({
    url: '/user/userinfo/refresh',
    method: 'post',
  });
}
// 注册方法
export function register(data) {
  return request({
    url: '/user/userinfo/register',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: data,
  });
}
//找回登录密码
export function forgotpass(parm) {
  return request({
    url: '/user/userinfo/forgotpass',
    method: 'post',
    headers: {
      isToken: false,
    },
    data: parm,
  });
}
//获取用户账户信息
export function getUserBalanceApi(parm) {
  return request({
    url: '/user/userbalance/info',
    method: 'post',
    data: parm,
  });
}
// 获取用户实名信息
export function getUserExtInfo(parm) {
  return request({
    url: '/user/userextinfo/info',
    method: 'post',
    data: parm,
  });
}

//获取消息列表信息
export function getmessage(parm) {
  return request({
    url: '/user/userinfo/getmessage',
    method: 'post',
    data: parm,
  });
}

//获取系统配置信息
export function getiniinfo(parm) {
  return request({
    url: '/user/userinfo/getiniinfo',
    method: 'post',
    data: parm,
  });
}
//获取首页banner
export function rotationmap(parm) {
  return request({
    url: '/user/userinfo/rotationmap',
    method: 'post',
    data: parm,
  });
}
//获取充币地址
export function applyaddress(parm) {
  return request({
    url: '/user/userinfo/applyaddress',
    method: 'post',
    data: parm,
  });
}
